import {createEventBus} from '@malt/vue-event-bus/create-event-bus';
import type {FreelancerDrawerTab} from '@/features/project-view/types';

type Events = {
    closePopins: undefined;
    openProjectListFilterDrawer: undefined;
    showFreelancerDrawer: {tab: FreelancerDrawerTab};
    hideFreelancerDrawer: undefined;
    displayPayLaterEligibilitySuccessModal: number | undefined;
    forceNavigateToFirstResult: string;
    handleAddPurchaseOrderLater: undefined;
    handleAddPurchaseOrderNow: undefined;
    openChangeQuoteOwnerModal: undefined;
};

export const eventBus = createEventBus<Events>();
